module.exports = __webpack_public_path__ + "59cda2da7f634366d2b0e6da51f1bbb7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Datar.png
// module id = lHqN
// module chunks = 0